import React from "react";
import "../App.css";

interface AppLoaderProps {
  message?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({ message = "Loading..." }) => {
  return (
    <div className="app-loader">
      <div className="loader-content">
        <div className="loader-spinner"></div>
        <h2 style={{ fontFamily: "Roundo" }}>
          <img src="/clusterview-logo-with-text.svg" alt="ClusterView" />
        </h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default AppLoader;
